import Layout4Admin1 from "components/layout/Layout4Admin1";
import Css from './Customer.module.css';
import {useParams, useNavigate } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";
import { useEffect, useState } from "react";
import { Form,Button, Col, Row, Breadcrumb } from "react-bootstrap";
import { AddCommar, ConvertDateTimeToText, ConvertDateToText, TextDate } from "components/MyControl";
import  TablePackageNormalPremium  from "components/pages/admin/TablePackageNormalPremium";
import  TablePackageVolumePremium  from "components/pages/admin/TablePackageVolumePremium";
import moment from "moment";

export default function PackageDetail(){

    const api = new ApiConection();
    const navigate = useNavigate();
    const { id } = useParams();
    const [validated, setValidated] = useState(false);
    const [alert, setAlert] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('view');
    const [initialData, setInitialData] = useState({});
    const [calculatedPrices, setCalculatedPrices] = useState([]);
    const [simulate, setSimulate] = useState({
        recommend: false,
        package_type: 'package',
    });

    const [packagePeriod, setPackagePeriod] = useState([]);
    const [packageFeature, setPackageFeature] = useState([]);
    const [packageSupport, setPackageSupport] = useState([]);
    const [packagePremiums, setPackagePremiums] = useState([]);
    const [createMode,setCreateMode] = useState(false);
    const urlPathName = window.location.pathname;

    const handleSetSimulate = async (event) => {
        const { name, value, checked, type } = event.target;
        const package_type = (name === 'package_type')? value : '';
        if (!name) return;

        if(package_type === 'addon-user' || package_type === 'addon-storage'){
            setSimulate({ ...simulate, arr_premium: [] });
        }
        else if(package_type === 'package' || package_type === 'free'){
            let premiums = packagePeriod.map(obj => ({
                package_master_id: simulate?.id ?? null,
                master_period_id: obj.id,
                total: 0,
                active: true,
            }));
            setSimulate({ ...simulate, arr_premium: [...premiums] });
        }
            
        if(type === 'checkbox'){
            setSimulate(preData => { return { ...preData, [name]: checked } });
        }else{
            setSimulate(preData => { return { ...preData, [name]: value } });
        }
        
    }

    const handleSetSimulatePremiums = async (event) => {
        const { name, value, checked, type } = event.target;
        let premiums = simulate?.arr_premium ?? [];
        const [me_name, period_id, volumeId] = name.split('|');

        let premium = premiums.find(x => x.master_period_id === parseInt(period_id) 
        && ((simulate?.package_type === 'addon-user' && x.package_master_user_volume_id === parseInt(volumeId)) || simulate?.package_type !== 'addon-user' ) 
        &&  ((simulate?.package_type === 'addon-storage' && x.package_master_storage_volume_id  === parseInt(volumeId)) || simulate?.package_type !== 'addon-storage' )) ;
            
            if (premium) {

                let tmpValue = isNaN(parseInt(value))? 0 : parseInt(value);
                premium[me_name] = type === 'checkbox' ? checked : tmpValue ;
            } else {
            
                    premium = {
                        package_master_id: simulate?.id,
                        master_period_id: parseInt(period_id),
                        package_master_user_volume_id: (simulate?.package_type === 'addon-user')? parseInt(volumeId) : null,
                        package_master_storage_volume_id: (simulate?.package_type === 'addon-storage')? parseInt(volumeId) : null,
                        total: 0,
                        active: true,
                    };

                    let tmpValue = isNaN(parseInt(value))? 0 : parseInt(value);

                    premium[me_name] = type === 'checkbox' ? checked : tmpValue ;
                    premiums.push(premium);
            }

            setSimulate({ ...simulate, arr_premium: [...premiums] });
    };

    const getPackageFeature = async () => {
        const response = await api.getData('api/Master/master-package-feature');

        if (response.status === true) {
            setPackageFeature(response.data);

        }
    }

    const getPackageSupport = async () => {
        const response = await api.getData('api/Master/master-package-support');

        if (response.status === true) {
            setPackageSupport(response.data);

        }
    }

    const getPackagePeriod = async () => {
        const response = await api.getData('api/packagePeriod/edit');

        if (response.status === true) {
            setPackagePeriod(response.data);
        }else{
            setPackagePeriod([]);
        }
    }
    
    const getData = async () => {
        const response = await api.getData(`api/package/${id}`);
        if (response.status === true) {

            let data = response.data;
            if(data?.effective_date !== null) data.effective_date = moment(data?.effective_date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');
            if(data?.expiry_date !== null) data.expiry_date = moment(data?.expiry_date, 'YYYY-MM-DDTHH:mm:ss').format('DD/MM/YYYY');

            setSimulate(response.data);
            setInitialData(response.data);
        } 

        if((simulate?.package_type === 'package' || simulate?.package_type === 'free') && response.data === undefined){
            let premiums = packagePeriod.map(obj => ({
                package_master_id: response?.data?.id ?? null,
                master_period_id: obj.id,
                total: 0,
                active: false,
            }));
            setSimulate({ ...simulate, arr_premium: [...premiums] });
        }
    };
    

    const calculatePrice = () => {
        const price = simulate;
        const multiplyPeriod = packagePeriod;
        
        let userPrice = price.number_of_user * price.price_of_user;
        let storagePrice = price.number_of_storage * price.price_of_storage;
        let calPrice = userPrice + storagePrice;
        
        let premiums = simulate?.arr_premium ?? [];
        let arrVolume = simulate?.arr_volume ?? [];
        
        if (simulate.package_type === 'package' || simulate.package_type === 'free') {
            let calculatedPrices = multiplyPeriod.map((period) => {
                let multiplier = 0;
                if (period.multiply.includes('m')) {
                    multiplier = parseInt(period.multiply.replace('m', ''), 10);
                } else if (period.multiply.includes('d')) {
                    multiplier = parseInt(period.multiply.replace('d', ''), 10);
                }
                let total = calPrice * multiplier;
            
                let premium = premiums.find(x => x.master_period_id === period.id);
                if (premium) {
                    premium.total = total;
                } else {
                    premiums.push({
                        package_master_id: simulate?.id,
                        master_period_id: period.id,
                        total: total,
                        active: true,
                    });
                }
            
                return total;
            });
    
            setCalculatedPrices(calculatedPrices);
            setSimulate({ ...simulate, arr_premium: premiums });
    
        } else if (simulate.package_type === 'addon-user' || simulate.package_type === 'addon-storage') {
            let volumes = arrVolume;
            let calculatedPrices = multiplyPeriod.map((period) => {
                let multiplier = 0;
                if (period.multiply.includes('m')) {
                    multiplier = parseInt(period.multiply.replace('m', ''), 10);
                } else if (period.multiply.includes('d')) {
                    multiplier = parseInt(period.multiply.replace('d', ''), 10);
                }
                let calMul = calPrice * multiplier;
                return volumes.map((object) => {
                    let volume = object?.volume || 0;
                    let total = calMul * volume;
                    let premium = premiums.find(x => x.master_period_id === period.id && (simulate.package_type === 'addon-user' ? x.package_master_user_volume_id === object.id : x.package_master_storage_volume_id === object.id));
                    
                    if (premium) {
                        premium.total = total;
                    } else {
                        premiums.push({
                            package_master_id: simulate?.id,
                            master_period_id: period.id,
                            [simulate.package_type === 'addon-user' ? 'package_master_user_volume_id' : 'package_master_storage_volume_id']: object.id,
                            total: total,
                            active: true,
                        });
                    }
                    return total;
                });
            });
    
            setCalculatedPrices(calculatedPrices);
            setSimulate({ ...simulate, arr_premium: premiums });
        }
    };

    const handleCancel = (event) => {
        if (createMode) {
            navigate('/setting/package'); 
        }else{
            setSimulate(initialData)
            setMode('view')
        }
    }

    const handleBreadcrumbClick = (e) => {
        navigate('/setting/package');
    };

    useEffect(() => {
        getPackageFeature();
        getPackageSupport();
        getPackagePeriod();
    }, [])

    useEffect(() => {
        getData();
    }, [packageFeature,packagePeriod,packageSupport])

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();

        setValidated(false);
        setAlert('');
        setLoading(true);

        if (form.checkValidity() === false) {
            event.stopPropagation();
            setValidated(true);
            setLoading(false);
            return;
        }

        let request = {
            seq : simulate?.seq,
            recommend: simulate?.recommend,
            code: simulate?.code,
            name: simulate?.name,
            description: simulate?.description,
            remark: simulate?.remark,
            price_of_user: simulate?.price_of_user,
            price_of_storage: simulate?.price_of_storage,
            number_of_user: simulate?.number_of_user,
            number_of_storage: simulate?.number_of_storage,
            total: simulate?.total,
            effective_date: simulate?.effective_date,
            expiry_date: simulate?.expiry_date,
            package_type: simulate?.package_type,
            color_code: simulate?.color_code,
            active: simulate?.active,
            arr_volume: simulate?.arr_volume,
            arr_feature: simulate?.arr_feature,
            arr_support: simulate?.arr_support,
            arr_premium: simulate?.arr_premium,
        }

        let effective_date = moment(simulate?.effective_date, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
        let expiry_date = moment(simulate?.expiry_date, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');

        if(effective_date !== 'Invalid date') request.effective_date = effective_date;
        if(expiry_date !== 'Invalid date') request.expiry_date = expiry_date;


        if (urlPathName === (process.env.PUBLIC_URL+'/setting/package/create')){
            const response = await api.postData(`api/Package`, request)
            if (response.status === true) {
                navigate('/setting/package');
            } else{
                setAlert(response.message);
            }
        }else{
            const response = await api.putData(`api/package/${id}`,request);
            if (response.status === true) {
                await getData();
                setMode('view');
            } else {
                setAlert(response.message);
                setMode('edit');
            }
        }

        setLoading(false);
    }

    const NormalPremium = () => {
        const isPackageOrFree = simulate.package_type === 'package' || simulate.package_type === 'free';
        const hasPremiums = simulate?.arr_premium?.length > 0;
        return isPackageOrFree && hasPremiums;
    };

    const VolumePremium = () => {
        const isUserOrStorage = simulate.package_type === 'addon-user' || simulate.package_type === 'addon-storage';
        const hasPremiums = true
        return isUserOrStorage && hasPremiums;
    };

    const getSimulate = async(event) =>{
        const response = await api.putData(`api/package/${id}/mode/calc`,simulate);

        if(response.status === true)
            setSimulate(response.data);
    }

    useEffect(() => {
        if (urlPathName === (process.env.PUBLIC_URL+'/setting/package/create')){
            setMode('edit');
            setCreateMode(true);
        }
        
    },[urlPathName])
    /*
    useEffect(() => {
        if (simulate !== undefined) {
            const delay = setTimeout(() => {
                // เรียกใช้ฟังก์ชันสำหรับการคำนวณผลลัพธ์ที่ต้องการ
                getSimulate();
            }, 500);

            return () => clearTimeout(delay);
        }
    }, [simulate]);*/

    return(
        <Layout4Admin1 role="admin">
            <div className={Css.Block_Transparent}>
                <div className='contrainermt-3 mb-3'>
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={handleBreadcrumbClick}>รายการแพ็กเกจ</Breadcrumb.Item>
                        <Breadcrumb.Item active>
                            {
                                mode === 'view' ? 'ข้อมูลแพ็กเกจ' :
                                createMode === true ? 'สร้างแพ็กเกจ' :
                                'แก้ไขแพ็กเกจ'
                            }
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <Form noValidate validated={validated} onSubmit={event => handleSubmit(event)} >
                        <div className={`border rounded p-4 bg-white shadow w-100`}>
                            <div>
                                <Row>
                                    <Col>
                                        <h5 className='text-start mb-0'>
                                            {
                                                mode === 'view' ? 'ข้อมูลแพ็กเกจ' :
                                                createMode === true ? 'สร้างแพ็กเกจ' :
                                                'แก้ไขแพ็กเกจ'
                                            }
                                        </h5>
                                        <Form.Text className="mb-5">ข้อมูลตัวแปรต่างๆ ที่ระบบ หรือโปรแกรมใช้งาน เมื่อทำการบันทึก จะมีผลกับระบบทันที</Form.Text>
                                    </Col>
                                    <Col className='text-end'>
                                        {
                                            mode === 'view' &&
                                            <Button variant="outline-secondary" type="button" className=''
                                                onClick={event => setMode('edit')}>
                                                แก้ไข
                                                <i className="ms-2 fa-solid fa-pencil"></i>
                                            </Button>
                                        }
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-5">
                                <Row className='mb-5'>
                                    <Col className="me-3">
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รหัสแพ็กเกจ</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'code'}
                                                value={simulate?.code}
                                                onChange={handleSetSimulate}
                                                placeholder="รหัสแพ็กเกจ" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ชื่อแพ็กเกจ</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'name'}
                                                value={simulate?.name}
                                                onChange={handleSetSimulate}
                                                placeholder="ชื่อแพ็กเกจ" required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ประเภท</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label className='d-block pt-2 pb-1 '>{simulate?.package_type}</Form.Label>
                                            }
                                            {
                                                mode === 'edit' &&
                                                <Form.Select 
                                                    name={'package_type'}
                                                    value={simulate?.package_type}
                                                    required={true}
                                                    placeholder="ประเภท"
                                                    onChange={handleSetSimulate} >
                                                    <option value={'package'}>package</option>
                                                    <option value={'free'}>free</option>
                                                    <option value={'semi'}>semi</option>
                                                    <option value={'addon-user'}>addon-user</option>
                                                    <option value={'addon-storage'}>addon-storage</option>
                                                </Form.Select>
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>สีแทนแพ็กเกจ</Form.Label>
                                            <Form.Control 
                                                type="color"
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'color_code'}
                                                value={simulate?.color_code}
                                                onChange={handleSetSimulate}
                                                placeholder="สีแทนแพ็กเกจ"
                                                disabled={(mode === 'view') ? true : false}
                                                required={true} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>แพ็กเกจแนะนำ</Form.Label>
                                            <Form.Switch 
                                                name={'recommend'}
                                                disabled={(mode === 'view') ? true : false}
                                                checked={simulate?.recommend}
                                                placeholder="แพ็กเกจแนะนำ" 
                                                onChange={handleSetSimulate} />
                                        </Form.Group> 
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>รายละเอียด</Form.Label>
                                            <Form.Control type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'description'}
                                                value={simulate?.description}
                                                onChange={handleSetSimulate}
                                                placeholder="รายละเอียด" required={true}
                                                as="textarea" rows={3} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>วันที่เริ่มต้น</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label as={Row} className="ms-1"  >{(simulate?.effective_date === null)?'-':simulate?.effective_date}</Form.Label>
                                            }
                                            {
                                                mode ==='edit' &&
                                                <TextDate   name="effective_date" 
                                                    value={simulate?.effective_date}
                                                    placeholder="วันที่เริ่มต้น"
                                                    onChange={handleSetSimulate} />
                                            }
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>วันที่สิ้นสุด</Form.Label>
                                            {
                                                mode === 'view' &&
                                                <Form.Label as={Row} className="ms-1"  >{(simulate?.expiry_date === null)?'-':simulate?.expiry_date}</Form.Label>
                                            }
                                            {
                                                mode ==='edit' &&
                                                <TextDate   name="expiry_date" 
                                                    value={simulate?.expiry_date}
                                                    placeholder="วันที่สิ้นสุด"
                                                    onChange={handleSetSimulate} />
                                            }
                                        </Form.Group>
                                        <Row>
                                            <Col>
                                                <Form.Group className='mb-3'>
                                                    <Form.Label className='label-title'>จำนวนผู้ใช้งาน</Form.Label>
                                                    <Form.Control type={'number'}
                                                        plaintext={(mode === 'view') ? true : false}
                                                        readOnly={(mode === 'view') ? true : false}
                                                        className=''
                                                        name={'number_of_user'}
                                                        value={simulate?.number_of_user}
                                                        onChange={handleSetSimulate}
                                                        placeholder="จำนวนผู้ใช้งาน" />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group className='mb-3'>
                                                    <Form.Label className='label-title'>ราคา/ผู้ใช้</Form.Label>
                                                    <Form.Control type={'number'}
                                                        plaintext={(mode === 'view') ? true : false}
                                                        readOnly={(mode === 'view') ? true : false}
                                                        className=''
                                                        name={'price_of_user'}
                                                        value={simulate?.price_of_user}
                                                        onChange={handleSetSimulate}
                                                        placeholder="ราคา/ผู้ใช้" />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                       <Row>
                                            <Col>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>จำนวนพื้นที่ใช้งาน(GB)</Form.Label>
                                                <Form.Control type={'number'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'number_of_storage'}
                                                    value={simulate?.number_of_storage}
                                                    onChange={handleSetSimulate}
                                                    placeholder="จำนวนพื้นที่ใช้งาน(GB)" />
                                            </Form.Group>
                                            </Col>
                                            <Col>
                                            <Form.Group className='mb-3'>
                                                <Form.Label className='label-title'>ราคา/ 1 GB</Form.Label>
                                                <Form.Control type={'number'}
                                                    plaintext={(mode === 'view') ? true : false}
                                                    readOnly={(mode === 'view') ? true : false}
                                                    className=''
                                                    name={'price_of_storage'}
                                                    value={simulate?.price_of_storage}
                                                    onChange={handleSetSimulate}
                                                    placeholder="ราคา/ 1 GB" />
                                            </Form.Group>
                                            </Col>
                                       </Row>
                                       <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ราคารวม</Form.Label>
                                            <Form.Label as={Row} className='label-title ms-1'>{simulate?.total}</Form.Label>
                                            
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>หมายเหตุ</Form.Label>
                                            <Form.Control 
                                                type={'text'}
                                                plaintext={(mode === 'view') ? true : false}
                                                readOnly={(mode === 'view') ? true : false}
                                                className=''
                                                name={'remark'}
                                                value={simulate?.remark}
                                                onChange={handleSetSimulate}
                                                placeholder="หมายเหตุ" 
                                                as="textarea" rows={3} />
                                        </Form.Group>
                                        <Form.Group className='mb-3'>
                                            <Form.Label className='label-title'>ใช้งาน</Form.Label>
                                            <Form.Switch name={'active'}
                                                disabled={(mode === 'view') ? true : false}
                                                checked={simulate?.active}
                                                placeholder="ใช้งาน" 
                                                onChange={handleSetSimulate} />
                                        </Form.Group> 
                                    </Col>
                                    <Col className="me-3">
                                    {
                                        !createMode &&
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">ผู้บันทึก</Form.Label>
                                            <Form.Label>{simulate?.modify_by}&nbsp;</Form.Label>
                                        </Form.Group>
                                        
                                    }
                                        <Form.Group as={Row} className="mb-3">
                                            <Form.Label className="label-title">วันที่บันทึกล่าสุด</Form.Label>
                                            <Form.Label>{ConvertDateTimeToText(simulate?.modify_date)}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>

                                {
                                    (createMode && NormalPremium() || NormalPremium()) &&
                                    <TablePackageNormalPremium
                                        simulate={simulate}
                                        setSimulate={setSimulate}
                                        packagePeriod={packagePeriod}
                                        handleSetSimulatePremiums={handleSetSimulatePremiums}
                                        calculatePrice={calculatePrice}
                                        mode={mode}
                                        calculatedPrices={calculatedPrices}
                                    />
                                }

                                {
                                    (createMode && VolumePremium() || VolumePremium()) &&
                                    <TablePackageVolumePremium
                                        simulate={simulate}
                                        setSimulate={setSimulate}
                                        packagePeriod={packagePeriod}
                                        handleSetSimulatePremiums={handleSetSimulatePremiums}
                                        calculatePrice={calculatePrice}
                                        mode={mode}
                                        calculatedPrices={calculatedPrices}
                                    />
                                }
                                {/* {
                                    (simulate.package_type === 'package' || simulate.package_type === 'free') &&
                                    <>
                                        <h6>Feature</h6>
                                        <Row className="mb-5">
                                            <table className="table border">
                                                <thead className="table-secondary">
                                                    <tr>
                                                        <th></th>
                                                        <th>feature</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                            {
                                                packageFeature?.map((obj,index) => (
                                                    <tr key={index}>{}
                                                        <td>
                                                            <Form.Check type={'checkbox'}
                                                                name={'is_had'}
                                                                readOnly={true}
                                                                checked={simulate?.arr_feature?.find(x => x.id === obj.id)?.is_had ?? false}
                                                            />
                                                        </td>
                                                        <td className="p-2">
                                                            {obj.description}
                                                        </td>
                                                    </tr>
                                                    
                                                ))
                                            }
                                                    
                                                </tbody>
                                            </table>
                                        </Row>
                                    </>
                                } */}
                                  
                                {
                                    alert != '' &&
                                    <div className="alert alert-danger" role="alert">
                                        {alert}
                                    </div>
                                }

                                    {createMode && (
                                        <Row>
                                            <Col>
                                            <>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={handleCancel}  >
                                                ยกเลิก
                                            </Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5' >
                                                สร้าง
                                                {loading === true && (
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </Button>
                                            </>
                                            </Col>
                                        </Row>
                                    )}

                                {
                                    !createMode && mode === 'edit' &&
                                    <Row>
                                        <Col>
                                            <Button variant="outline-secondary" type="button" className='ps-5 pe-5 me-1'
                                                onClick={event => handleCancel(event)}  >ยกเลิก</Button>
                                            <Button variant="primary" type="submit" className='ps-5 pe-5'
                                                disabled={loading}
                                            >บันทึก
                                                {
                                                    loading === true &&
                                                    <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                }
                                            </Button>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </Layout4Admin1>
    )
}